import { render, staticRenderFns } from "./SetSelection.vue?vue&type=template&id=410b7834&scoped=true"
import script from "./SetSelection.vue?vue&type=script&lang=js"
export * from "./SetSelection.vue?vue&type=script&lang=js"
import style0 from "./SetSelection.vue?vue&type=style&index=0&id=410b7834&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b7834",
  null
  
)

export default component.exports